import optc from '../optc.json'
import dayjs from 'dayjs'
// date-time config
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const tz = "America/Toronto"
dayjs.extend(utc);
dayjs.extend(timezone);

export function parseVehData(data) {

  let parseAllR = [];

  data.forEach((e) => {
    let timezone = optc.optc.find((f) => { return f.groupe == e.groupe }).timezone;
    let timeFormat = '';

    if (parseInt(e.timestr.substring(0, 2)) >= 0 && parseInt(e.timestr.substring(0, 2)) < 4) {
      timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).add(1, 'day').tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
    }

    let timeFormatTZ = dayjs(timeFormat).valueOf();

    parseAllR.push({
      time: timeFormatTZ,
      veh: Number(e.veh),
      groupe: e.groupe,
    })
  })

  return parseAllR

}

export function evalStats(data) {

  let stats = [];

  let minam = dayjs('2019-04-28 6:00:00').valueOf();
  let maxam = dayjs('2019-04-28 10:00:00').valueOf();

  let minop = dayjs('2019-04-28 10:00:00').valueOf();
  let maxop = dayjs('2019-04-28 15:00:00').valueOf();

  let minpm = dayjs('2019-04-28 15:00:00').valueOf();
  let maxpm = dayjs('2019-04-28 19:00:00').valueOf();

  data.forEach((e) => {
    let amdata = e.data.filter((f) => { return f.time >= minam && f.time < maxam }).map((f) => { return f.veh });
    let opdata = e.data.filter((f) => { return f.time >= minop && f.time < maxop }).map((f) => { return f.veh });
    let pmdata = e.data.filter((f) => { return f.time >= minpm && f.time < maxpm }).map((f) => { return f.veh });

    let maxveham = isFinite(Math.max(...amdata)) ? Math.max(...amdata) : 0;
    let maxvehop = isFinite(Math.max(...opdata)) ? Math.max(...opdata) : 0;
    let maxvehpm = isFinite(Math.max(...pmdata)) ? Math.max(...pmdata) : 0;

    let ampct = isFinite(maxveham / (Math.max(maxveham, maxvehop, maxvehpm)) * 100) ?
      maxveham / (Math.max(maxveham, maxvehop, maxvehpm)) * 100 :
      0;
    let oppct = isFinite(maxvehop / (Math.max(maxveham, maxvehop, maxvehpm)) * 100) ?
      maxvehop / (Math.max(maxveham, maxvehop, maxvehpm)) * 100 :
      0;
    let pmpct = isFinite(maxvehpm / (Math.max(maxveham, maxvehop, maxvehpm)) * 100) ?
      maxvehpm / (Math.max(maxveham, maxvehop, maxvehpm)) * 100 :
      0;

    stats.push({
      groupe: e.groupe,
      maxrtveham: maxveham,
      maxrtvehop: maxvehop,
      maxrtvehpm: maxvehpm,
      ampct,
      oppct,
      pmpct
    })
  })

  return stats

}


export function formatData(data, agency) {

  let formatted = [];

  const parseAllR = [];
  const parseAllP = [];

  data.forEach((e) => {

    let timezone = optc.optc.find((f) => { return f.operateur == e.reseau }).timezone;

    let timeFormat = '';

    if (parseInt(e.timestr.substring(0, 2)) >= 0 && parseInt(e.timestr.substring(0, 2)) < 4) {
      timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).add(1, 'day').tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
    }

    let timeFormatTZ = dayjs(timeFormat).valueOf();

    parseAllR.push({
      time: timeFormatTZ,
      veh: Number(e.veh),
      groupe: e.groupe,
      agency: agency
    })

    parseAllP.push({
      time: timeFormatTZ,
      veh: Number(e.planned),
      groupe: e.groupe,
      agency: agency
    })

  })

  const vehDataRealtime = [];
  const vehDataPlanned = [];

  vehDataRealtime.push({
    agency: agency,
    data: parseAllR
  })

  vehDataPlanned.push({
    agency: agency,
    data: parseAllP
  })

  formatted.push(vehDataRealtime, vehDataPlanned);

  return formatted

}